// extracted by mini-css-extract-plugin
export default {"salesHeadline":"headline_salesHeadline__NYvx1","headlineRight":"headline_headlineRight__RY4e4"};